'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function Controller($window, $scope, $filter, $state, AppConstants, PageHeading, Line, StationComponent, BusComponent, Toast) {
	'ngInject';

	var vm = this;
	vm.clickHandler = clickHandler;
	vm.lockSeat = lockSeat;
	vm.updateSeats = updateSeats;
	vm.chooseBus = chooseBus;
	vm.fetchBus = fetchBus;
	vm.buses = Line.buses;
	vm.bus = {};
	vm.date = '';
	vm.points = [];
	vm.showStations = false;
	vm.showBusSchema = false;
	vm.showCopyDate = false;
	vm.seatsCount = 0;
	vm.seats = [];
	vm.unavailableSeats = [];
	vm.currentDate = new Date();
	vm.currentDate.setDate(vm.currentDate.getDate() - 1);
	vm.dateCache = '';
	vm.checkForChangesBeforeCopy = checkForChangesBeforeCopy;

	vm.seatsChanged = false;

	activate();

	function activate() {
		var heading = $filter('translate')('HEADING.SEATS_FROM_LINE') + ' ' + Line.translation.name;
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.LOCK_SEATS');

		PageHeading.setPageHeading(heading, title);
	}

	// Stations click handler
	function clickHandler(event, point, index) {
		$scope.$apply(function () {

			// Check if the selected station is selected already
			if (!vm.points[index].isSelected) {
				// Find the first selected buses from all of the selected station at the moment if any
				var firstSelectedStation = _lodash2['default'].find(vm.points, 'isSelected');
				if (firstSelectedStation) {
					// Get the locked seats for the two buses in the form of array for comparision
					var currentLockedSeats = _lodash2['default'].pluck(firstSelectedStation.lockedSeats, 'number');
					var newLockedSeats = _lodash2['default'].pluck(point.lockedSeats, 'number');
					// Check if there are any differences in the locked seats of the two buses
					var lockedSeatsMatch = currentLockedSeats.length === newLockedSeats.length && !_lodash2['default'].difference(currentLockedSeats, newLockedSeats).length;

					// Get all the taken seats for the two buses and put them in a single array for comparison
					var currentPaidSeats = _lodash2['default'].pluck(_lodash2['default'].filter(firstSelectedStation.unavailableSeats, { 'status': 'paid' }), 'number');
					var currentReservedSeats = _lodash2['default'].pluck(_lodash2['default'].filter(firstSelectedStation.unavailableSeats, { 'status': 'reserved' }), 'number');
					var currentTakenSeats = _lodash2['default'].union(currentPaidSeats, currentReservedSeats);

					var newPaidSeats = _lodash2['default'].pluck(_lodash2['default'].filter(point.unavailableSeats, { 'status': 'paid' }), 'number');
					var newReservedSeats = _lodash2['default'].pluck(_lodash2['default'].filter(point.unavailableSeats, { 'status': 'reserved' }), 'number');
					var newTakenSeats = _lodash2['default'].union(newPaidSeats, newReservedSeats);

					// Check if there are any differences in the taken seats of the two buses
					var takenSeatsMatch = currentTakenSeats.length === newTakenSeats.length && !_lodash2['default'].difference(currentTakenSeats, newTakenSeats).length;

					if (!takenSeatsMatch || !lockedSeatsMatch) {
						// If they do not match deselect all other buses
						vm.points.forEach(function (item) {
							if (item.isSelected) {
								item.isSelected = false;
								item.active = false;
							}
						});

						// Visualize the locked seats for the newly selected station if no match
						vm.unavailableSeats = point.unavailableSeats;
						vm.loadSeats();
					}
				} else {
					// Visualize the locked seats for the newly selected station if no other station was selected
					vm.unavailableSeats = point.unavailableSeats;
					vm.loadSeats();
				}
				vm.points[index].isEditing = true;
				vm.points[index].isSelected = true;
				vm.points[index].active = true;
				vm.showBusSchema = true;
			} else {
				vm.points[index].isSelected = false;
				vm.points[index].active = false;
				if (!_lodash2['default'].find(vm.points, 'isSelected')) {
					vm.showBusSchema = false;
				}
			}
			vm.redraw();
		});
	}

	// Seat click handler
	function lockSeat(seat) {
		vm.seatsChanged = true;

		if (!seat.active) {
			seat.active = true;
			seat.color = 'locked';
			seat.status = 'locked';
			// Add the seat in each selected station
			vm.points.forEach(function (station) {
				if (station.isSelected) {
					station.lockedSeats.push({
						'number': seat.number,
						'status': 'locked'
					});

					station.unavailableSeats.push({
						'number': seat.number,
						'status': 'locked'
					});
				}
			});
		} else if (seat.status === 'locked') {
			seat.active = false;
			seat.status = 'free';
			// Remove the seat in each selected station
			vm.points.forEach(function (station) {
				if (station.isSelected) {
					_lodash2['default'].remove(station.lockedSeats, function (item) {
						return item.number === seat.number;
					});

					_lodash2['default'].remove(station.unavailableSeats, function (item) {
						return item.number === seat.number;
					});
				}
			});
		} else {
			Toast.error($filter('translate')('ERRORS.TAKEN_SEAT'));
		}
	}

	function updateSeats(busId, date, stations) {
		var params = {
			'bus_id': busId,
			'date': date,
			'stations': []
		};

		stations.forEach(function (station) {
			// if (station.isEditing) {

			if (station.lockedSeats.length) {
				params.stations.push({
					'station_id': station.station.id,
					'seats': station.lockedSeats
				});
			}
		});

		StationComponent.saveLockedSeats(params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				vm.seatsChanged = false;
				Toast.success($filter('translate')('SUCCESS.SAVE_LOCKED_SEATS'));
			}
		});
	}

	function chooseBus(bus, date) {
		if (vm.seatsChanged) {
			if ($window.confirm($filter('translate')('CONFIRM.LOCKED_SEATS_NOT_SAVED'))) {
				vm.seatsChanged = false;
				vm.dateCache = date;
				vm.bus = bus;
				fetchBus(bus.id, date);
			} else {
				vm.date = vm.dateCache;
			}
		} else {
			vm.dateCache = date;
			vm.bus = bus;
			fetchBus(bus.id, date);
		}
	}

	function fetchBus(busId, date) {
		if (date && busId) {
			// Clear the page
			vm.points = [];
			vm.showStations = false;
			vm.showBusSchema = false;
			vm.showCopyDate = false;
			vm.seatsCount = 0;
			vm.unavailableSeats = [];

			// Fetch bus data
			BusComponent.fetchBus(busId, date).then(function (res) {
				if (res.data && res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					vm.bus = res;
					vm.seatsCount = res.seats;
					loadCanvasPoints(res.stations);
					vm.showCopyDate = true;
					vm.showStations = true;
				}
			});
		} else {
			vm.showStations = false;
			vm.showBusSchema = false;
			vm.showCopyDate = false;
		}
	}

	function loadCanvasPoints(stations) {
		var stationInfo = undefined;
		Line.stations.forEach(function (station) {
			stationInfo = _lodash2['default'].find(stations, { 'id': station.id });
			// Fill the station points of the canvas
			if (stationInfo) {
				vm.points.push({
					'unavailableSeats': stationInfo.seats,
					'lockedSeats': _lodash2['default'].filter(stationInfo.seats, { 'status': 'locked' }),
					'station': {
						'id': station.id.toString(),
						'name': station.translation.name
					},
					'name': station.city.translation.name,
					'isEditing': false,
					'active': false,
					'isSelected': false
				});
			}
		});
		vm.redraw();
	}

	// Check for changes before copy seats
	function checkForChangesBeforeCopy(bus, date) {
		if (!date) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if (vm.seatsChanged) {
			if ($window.confirm($filter('translate')('CONFIRM.LOCKED_SEATS_NOT_SAVED'))) {
				checkTargetBusBeforeCopy(bus, date);
			}
		} else {
			checkTargetBusBeforeCopy(bus, date);
		}
	}

	// Check and validate the target bus if copy is available
	function checkTargetBusBeforeCopy(bus, date) {
		// Fetch bus data
		BusComponent.fetchBus(bus.id, date).then(function (res) {
			if (res.errors) {
				Toast.responseError(res.errors.error);
			} else {
				var copyAvailable = true;
				var shouldOverwrite = false;

				angular.forEach(res.stations, function (station) {
					// Check if there is any taken or locked seats in the target tbus
					if (station.seats.length) {
						for (var i = 0; i < station.seats.length; i++) {
							// Check if there are taken seats in the target bus
							if (station.seats[i].status === 'paid' || station.seats[i].status === 'reserved') {
								// Target bus has taken seats and seats cannot be copied
								copyAvailable = false;
								Toast.error($filter('translate')('ERRORS.UNABLE_TO_COPY_SEATS_DUE_TO_TAKEN_SEATS'));
								break;
							}
						}

						// Target bus has locked seats
						shouldOverwrite = true;
					}
				});

				if (copyAvailable) {
					if (shouldOverwrite) {
						if ($window.confirm($filter('translate')('CONFIRM.OVERWRITE_LOCKED_SEATS'))) {
							copySeats(bus, date);
						}
					} else {
						copySeats(bus, date);
					}
				}
			}
		});
	}

	// Prepare the params for sending them to the server and send them
	function copySeats(bus, date) {
		var params = {
			'bus_id': bus.id,
			'date': date,
			'stations': []
		};

		// Prepare the station array for sending
		var tempStation = {};
		angular.forEach(bus.stations, function (station) {
			tempStation = {
				'station_id': station.id,
				'seats': []
			};

			// Prepare the seats array for each station
			if (station.seats.length) {
				station.seats.forEach(function (seat) {
					if (seat.status === 'locked') {
						tempStation.seats.push({
							'number': seat.number
						});
					}
				});
			}

			params.stations.push(tempStation);
		});

		StationComponent.saveLockedSeats(params).then(function (res) {
			if (res.data.errors) {
				Toast.responseError(res.data.errors);
			} else {
				Toast.success($filter('translate')('SUCCESS.COPY_LOCKED_SEATS'));
			}
		});
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/seats/edit/edit.controller.js
 **/